export default {
    // getToken() {
    //     return window.localStorage.getItem("token");
    // },
    // setToken(value) {
    //     window.localStorage.setItem("token", value);
    // },
    getToken() {
        const token = window.localStorage.getItem("access_token");
        if (token) {
            try{
                return JSON.parse(token);
            }catch{
                return null;
            }
        }
        return null;
    },
    setToken(value) {
        try{
            window.localStorage.setItem("access_token", JSON.stringify(value));
        }catch{
            window.localStorage.setItem("access_token", null);
        }
    }
}